import React from "react";

const TenantList = React.lazy(() =>
  import("./TenantList")
);

const TenantDetails = React.lazy(() =>
  import("./TenantDetails")
);

const TenantStatus = React.lazy(() =>
  import("./TenantStatus")
);

const EventDetail = React.lazy(() =>
  import("./EventDetail")
);

const tenantlistRoutes = [
  {
    path: "/tenants",
    element: <TenantList />,
  },
  {
    path: "/tenants/:id",
    element: <TenantDetails />,
  },
  {
    path: "/tenants/:id/status",
    element: <TenantStatus />,
  },
  {
    path: "/tenants/:id/events/:eventId",
    element: <EventDetail />,
  },
];

export default tenantlistRoutes;